import cookie from 'cookie'
import { action, computed, configure, observable } from 'mobx'
import AV from './av'
import { getSearch } from './util'
import i18n from './util/i18n'

configure({
  enforceActions: 'observed'
})

class Store {
  @observable step = 'login' // login regist reset signup

  constructor() {
    let o = getSearch()
    if (o.signup) {
      this.step = 'signup'
    } else if (o.login) {
      this.step = 'login'
    }
  }

  get user() {
    return AV.User.current()
  }

  get lang() {
    return cookie('lang') || (/^(\w|\s)+$/.test(document.title) ? 'en' : 'cn')
  }

  @computed get title() {
    let { step } = this
    return i18n(`title-${step}`)
  }

  @action setStep(step) {
    this.step = step
  }
}

export default new Store()
